import { render, staticRenderFns } from "./strictImage.vue?vue&type=template&id=0b54cbd1&"
import script from "./strictImage.vue?vue&type=script&lang=ts&"
export * from "./strictImage.vue?vue&type=script&lang=ts&"
import style0 from "./strictImage.vue?vue&type=style&index=0&id=0b54cbd1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports